/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UserAccountUpdateResult} from '../models/UserAccountUpdateResult';
import type {UsersAccountChangeRequest} from '../models/UsersAccountChangeRequest';

export interface GetAccountBulkChangeProgress$Request {
    id: string;
}

export interface GetAccountBulkChangeProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountBulkChangeProgressRequest = createAction<PayloadData<void, GetAccountBulkChangeProgress$Request>>('USER_ACCOUNT_BULK_CHANGE__GET_ACCOUNT_BULK_CHANGE_PROGRESS__REQUEST');
export const getAccountBulkChangeProgressSuccess = createAction<PayloadData<BulkProgress, GetAccountBulkChangeProgress$Request>>('USER_ACCOUNT_BULK_CHANGE__GET_ACCOUNT_BULK_CHANGE_PROGRESS__SUCCESS');
export const getAccountBulkChangeProgressFailure = createAction<PayloadData<Error, GetAccountBulkChangeProgress$Request, true>>('USER_ACCOUNT_BULK_CHANGE__GET_ACCOUNT_BULK_CHANGE_PROGRESS__FAILURE');

export const getAccountBulkChangeProgressActions = [
    getAccountBulkChangeProgressRequest,
    getAccountBulkChangeProgressSuccess,
    getAccountBulkChangeProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountBulkChangeProgress = (meta: GetAccountBulkChangeProgress$Request, config?: GetAccountBulkChangeProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAccountBulkChangeProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/accounts/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAccountBulkChangeResult$Request {
    id: string;
}

export interface GetAccountBulkChangeResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountBulkChangeResultRequest = createAction<PayloadData<void, GetAccountBulkChangeResult$Request>>('USER_ACCOUNT_BULK_CHANGE__GET_ACCOUNT_BULK_CHANGE_RESULT__REQUEST');
export const getAccountBulkChangeResultSuccess = createAction<PayloadData<UserAccountUpdateResult, GetAccountBulkChangeResult$Request>>('USER_ACCOUNT_BULK_CHANGE__GET_ACCOUNT_BULK_CHANGE_RESULT__SUCCESS');
export const getAccountBulkChangeResultFailure = createAction<PayloadData<Error, GetAccountBulkChangeResult$Request, true>>('USER_ACCOUNT_BULK_CHANGE__GET_ACCOUNT_BULK_CHANGE_RESULT__FAILURE');

export const getAccountBulkChangeResultActions = [
    getAccountBulkChangeResultRequest,
    getAccountBulkChangeResultSuccess,
    getAccountBulkChangeResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountBulkChangeResult = (meta: GetAccountBulkChangeResult$Request, config?: GetAccountBulkChangeResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAccountBulkChangeResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/accounts`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopAccountBulkChange$Request {
    id: string;
}

export interface StopAccountBulkChange$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopAccountBulkChangeRequest = createAction<PayloadData<void, StopAccountBulkChange$Request>>('USER_ACCOUNT_BULK_CHANGE__STOP_ACCOUNT_BULK_CHANGE__REQUEST');
export const stopAccountBulkChangeSuccess = createAction<PayloadData<void, StopAccountBulkChange$Request>>('USER_ACCOUNT_BULK_CHANGE__STOP_ACCOUNT_BULK_CHANGE__SUCCESS');
export const stopAccountBulkChangeFailure = createAction<PayloadData<Error, StopAccountBulkChange$Request, true>>('USER_ACCOUNT_BULK_CHANGE__STOP_ACCOUNT_BULK_CHANGE__FAILURE');

export const stopAccountBulkChangeActions = [
    stopAccountBulkChangeRequest,
    stopAccountBulkChangeSuccess,
    stopAccountBulkChangeFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopAccountBulkChange = (meta: StopAccountBulkChange$Request, config?: StopAccountBulkChange$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopAccountBulkChangeActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/accounts`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UserAccountBulkChange$Request {
    usersAccountChangeRequest: UsersAccountChangeRequest;
    reason?: string;
}

export interface UserAccountBulkChange$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const userAccountBulkChangeRequest = createAction<PayloadData<void, UserAccountBulkChange$Request>>('USER_ACCOUNT_BULK_CHANGE__USER_ACCOUNT_BULK_CHANGE__REQUEST');
export const userAccountBulkChangeSuccess = createAction<PayloadData<string, UserAccountBulkChange$Request>>('USER_ACCOUNT_BULK_CHANGE__USER_ACCOUNT_BULK_CHANGE__SUCCESS');
export const userAccountBulkChangeFailure = createAction<PayloadData<Error, UserAccountBulkChange$Request, true>>('USER_ACCOUNT_BULK_CHANGE__USER_ACCOUNT_BULK_CHANGE__FAILURE');

export const userAccountBulkChangeActions = [
    userAccountBulkChangeRequest,
    userAccountBulkChangeSuccess,
    userAccountBulkChangeFailure
] as const;

/**
 * @param {UsersAccountChangeRequest} meta.usersAccountChangeRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const userAccountBulkChange = (meta: UserAccountBulkChange$Request, config?: UserAccountBulkChange$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: userAccountBulkChangeActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/accounts`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.usersAccountChangeRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

